/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { MarkerClusterer } from "@react-google-maps/api";
import InfoMarkerParkAndRide from "./InfoMarker";

interface MarkerClustererParkAndRideProps {
    markerClustererCalculator: (markers: Array<any>) => any;
    clusterStyles: any;
    locations: any[];
}

const MarkerClustererParkAndRide: React.FC<MarkerClustererParkAndRideProps> = ({
    markerClustererCalculator,
    clusterStyles,
    locations,
}) => {
    return (
        <MarkerClusterer
            options={{
                clusterClass: "map-cluster-icon",
                calculator: markerClustererCalculator,
                styles: clusterStyles,
            }}
        >
            {(clusterer) =>
                locations.map((location, i) => (
                    <InfoMarkerParkAndRide key={i} location={location} clusterer={clusterer} />
                ))
            }
        </MarkerClusterer>
    );
};

export default MarkerClustererParkAndRide;
